import type { GridColDef } from "@mui/x-data-grid-premium";
import type { ReportingPeriod } from "@entrilia/shared/api/dataCollectionTypes";
import DataGrid from "@entrilia/shared/components/grid/DataGrid";
import GridTextHoverLink from "@entrilia/shared/components/grid/GridTextHoverLink";
import { reportingPeriodCaptionsMap } from "@entrilia/shared/utilities/enumCaptions";
import type { DataCollectionRequestTemplateVersion } from "../../../../api/types/dataCollectionTypes";
import useClientContext from "../../../../context/useClientContext";
import { pageRoutes } from "../../../../routes";
import { CategoriesCell } from "./dataRequestTemplatesGridProvider";

const NameCell = ({ row }: { row: DataCollectionRequestTemplateVersion }) => {
  const { clientCode } = useClientContext();

  return (
    <GridTextHoverLink
      to={`/${clientCode}/${pageRoutes.portfolio}/${pageRoutes.dataRequestTemplates}/${row.templateId}`}
      text={row.name}
    />
  );
};

const columnDefinitions: GridColDef<DataCollectionRequestTemplateVersion>[] = [
  {
    field: "name",
    headerName: "Name",
    flex: 2,
    minWidth: 160,
    renderCell: ({ row }) => <NameCell row={row} />,
  },
  {
    field: "reportingPeriod",
    headerName: "Period",
    flex: 1,
    minWidth: 160,
    valueFormatter: (value: ReportingPeriod) => (value ? reportingPeriodCaptionsMap[value] : ""),
  },
  {
    field: "scenarioName",
    headerName: "Scenario",
    flex: 1,
    minWidth: 160,
  },
  {
    field: "categories",
    headerName: "Category",
    flex: 1,
    minWidth: 160,
    renderCell: ({ row }) => <CategoriesCell row={row} />,
  },
  {
    field: "recipientObjectIds",
    headerName: "Companies",
    headerAlign: "right",
    align: "right",
    flex: 1,
    minWidth: 80,
    valueFormatter: (value: string[] | undefined) => (value?.length ?? 0).toLocaleString(),
  },
];

interface Props {
  rows: DataCollectionRequestTemplateVersion[];
  isLoading: boolean;
}

const DataRequestTemplatesGrid = ({ rows, isLoading }: Props) => (
  <DataGrid<DataCollectionRequestTemplateVersion>
    rows={rows}
    columns={columnDefinitions}
    noRowsText="No request templates"
    loading={isLoading}
    disableColumnReorder
    disableColumnSorting
  />
);

export default DataRequestTemplatesGrid;
